// FIX: should be in Elements/Color
export const ArticleColor = {
  dark: "rgba(59, 63, 75, 0.75)",
  light:
    "linear-gradient(90deg, rgba(0,150,209, 0.91) 0%, rgba(0,204,162, 0.91) 100%)",
};
